import { useNuxtApp } from "#imports";
export function useViewport() {
  return useNuxtApp().$viewport;
}
